<template lang="pug">
.odds-group
  template(v-if="!!details['ouh'] ")
    template(v-for="(det, ind) in details['ouh']")
      template(v-if="det && det[11] != 0 && det[12] != 0 && det[11] != '' && det[12] != ''")
          OddsItem(:odds="det" idx=12 :typ="oddsType" dataType="1" mode="ouh" label="over" :count="ind" :details="details" homeAway="1")
      template(v-else)
          OddsDisabled
          
      template(v-if="det && det[11] != 0 && det[12] != 0 && det[11] != '' && det[12] != ''")
          OddsItem(:odds="det" idx=11 :typ="oddsType" dataType="1" mode="ouh" label="under" :count="ind" :details="details" homeAway="2")
      template(v-else)
          OddsDisabled

</template>
<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import oddsItemMMO from "@/components/mobile/main/xitem/oddsItemMMO";

export default {
  components: {
    OddsItem,
    OddsDisabled,
    oddsItemMMO
  },
  mixins: [mixinHDPOUOdds],
  methods: {
    toggleMoreMarkets() {
      this.$emit("toggle-more-markets");
    },
  }
};
</script>
